import { AfterContentInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NzModalRef } from 'ng-zorro-antd/modal';

import { CreateSchainService } from './../../services';
import { AuthService } from '../../../../core/services';
import { sourceSchainRowLimitDescription } from '../../helpers/source-schain-partner-messages';

@Component({
  selector: 'app-create-dsp-source',
  standalone: false,
  templateUrl: './create-dsp-source.component.html',
  styleUrl: './create-dsp-source.component.scss'
})
export class CreateDspSourceComponent implements OnInit, AfterContentInit {
  @ViewChild('fileInput') protected fileInput: ElementRef;

  protected contentHeight = 'auto';

  constructor(
    protected createSchainService: CreateSchainService,
    private dialogRef: NzModalRef<CreateDspSourceComponent>,
    private authService: AuthService,
  ) { }

  protected get rowLimitDescription(): string {
    return sourceSchainRowLimitDescription(this.authService.partner.id);
  }

  public ngOnInit(): void {
    this.createSchainService.initComponent();
  }

  public ngAfterContentInit(): void {
    this.contentHeight = window.innerHeight - 250 + 'px';
    window.addEventListener('resize', () => {
      this.contentHeight = window.innerHeight - 250 + 'px';
    });
  }

  protected onUploadFile(event: Event): void {
    this.createSchainService.onUploadFileHandler(event, () => this.fileInput.nativeElement.value = '', 'dsp');
  }

  protected onDownloadFile(): void {
    this.createSchainService.onDownloadFileHandler();
  }

  protected onDeleteFile(): void {
    this.createSchainService.onDeleteFileHandler();
  }

  protected onCancelUpload(): void {
    this.createSchainService.onCancelUploadHandler('dsp');
  }

  protected onCloseModal(): void {
    this.createSchainService.onCloseModalHandler(() => this.dialogRef.close());
  }

  protected onCreateDspSource(): void {
    this.createSchainService.onCreateSourceSchainHandler(() => this.dialogRef.close(), 'dsp');
  }
}
